import { lazy } from "react";
//#region lib/types/lazy-implementation.js
/**
* Create one module-scoped lazy component whose loader failure resolves to a
* readable local implementation instead of reaching the owning UI entry's
* error boundary.
* @param load - Dynamic implementation loader; React invokes it once for the returned component type.
* @param unavailable - Permanent fallback used when the dynamic module cannot load.
* @returns A React lazy component shared by every rendered instance.
*/
function resilientLazy(load, unavailable) {
	return lazy(async () => {
		try {
			return { default: await load() };
		} catch {
			return { default: unavailable };
		}
	});
}
//#endregion
export { resilientLazy as t };

//# sourceMappingURL=lazy-implementation-8ID6ez-9.js.map